import React, { useState, lazy, useEffect, useRef } from "react";
import { Box, Typography, Tabs, Tab, Paper, Tooltip } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Specimen from "./specimens";
import PatientType from "./patientType";
import LabDepartment from "./labDepartment";
import CollectionType from "./collectionType";
import TestUnits from "./testUnits";
import TestParameters from "./testParameters";
import ParameterType from "./parameterType";
import AssetsCategory from "./assestsCategory";
import TestTab from "./testtab";
import Assets from "./assets";
import AssetBatch from "./assetBatch";
import LabPageHeader from "./pageHeader";
import LabPageFooter from "./pageFooter";
import ResultTemplate from "./resultTemplate";
import Medicine from "./medicin";
import MedicineGroup from "./medicinGroup";
import ExpenseCategory from "./expenseCategory";


const LabSettings = () => {
  const navigate = useNavigate();
  const { tab, id, name } = useParams();

  const tabConfigs = [
    { label: "Test", key: "test-tab" },

    { label: "Lab Department", key: "lab-department" },
    { label: "Specimen", key: "specimen" },

    { label: "Colection Type", key: "collection-type" },
    { label: "Patient Type", key: "patient-type" },
    { label: "Test Units", key: "test-units" },
    { label: "Test Parameters", key: "test-parameters" },
    { label: "Parameter Type", key: "parameter-type" },
    { label: "Assests Category", key: "assets-category" },
    { label: "Assests", key: "assets" },
    { label: "Asset Batch", key: "asset-batch" },
    { label: "Expense category", key: "expense-category" },
    { label: "Page Header", key: "page-header" },
    { label: "Page Footer", key: "page-footer" },
    { label: "Result Template", key: "result-template" },
    { label: "Culture Medicine Group", key: "medicine-group" },
    { label: "Culture Medicine", key: "medicine" },
  ];

  const visibleTabMap = tabConfigs.reduce((acc, item, index) => {
    acc[item.key] = index;
    return acc;
  }, {} as Record<string, number>);

  const initialTabIndex = tab ? visibleTabMap[tab] ?? 0 : 0;
  const [tabIndex, setTabIndex] = useState<number>(initialTabIndex);
  // const location = "individual";

  useEffect(() => {
    if (tab !== undefined && visibleTabMap[tab] !== undefined) {
      const targetIndex = visibleTabMap[tab];
      if (tabIndex) {
        setTabIndex(targetIndex);
      }
    }
  }, [tab]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    const tabKey = tabConfigs[newValue].key;
    let path = `/settings/${tabKey}`;

    navigate(path, { replace: true });
    setTabIndex(newValue);
  };

  const renderTabContent = () => {
    const key = tabConfigs[tabIndex]?.key;

    switch (key) {
      case "test-tab":
        return <TestTab />;

      case "lab-department":
        return <LabDepartment />;
      case "specimen":
        return <Specimen />;
      case "collection-type":
        return <CollectionType />;
      case "patient-type":
        return <PatientType />;
      case "test-units":
        return <TestUnits />;
      case "test-parameters":
        return <TestParameters />;
      case "parameter-type":
        return <ParameterType />;
      case "assets-category":
        return <AssetsCategory />;
      case "assets":
        return <Assets />;
      case "asset-batch":
        return <AssetBatch />;
      case "expense-category":
        return <ExpenseCategory />;
      case "page-header":
        return <LabPageHeader />;
      case "page-footer":
        return <LabPageFooter />;
      case "result-template":
        return  <ResultTemplate />;
      case "medicine-group":
        return <MedicineGroup />;
      case "medicine":
        return <Medicine />;
      default:
        return null;
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        allowScrollButtonsMobile
        scrollButtons="auto"
        sx={{
          borderBottom: 1,
          borderColor: "divider",

          "& .MuiTabs-flexContainer": {
            display: "flex",
            gap: 1,
            justifyContent: "start",
          },
          "& .MuiTab-root": {
            color: "#4d4d4dff",
            textTransform: "none",
            padding: "6px 6px",
            minWidth: "auto",
            fontWeight: "400",
          },
          "& .Mui-disabled": {
            color: "#9e9e9edc !important", // gray text for disabled
            cursor: "not-allowed",
          },
          "& .Mui-selected": {
            color: "primary.main",
          },
        }}
      >
        {tabConfigs.map((tab) => (
          <Tab
            key={tab.key}
            label={tab.label}
            sx={{ fontSize: ".75rem", pointerEvents: "auto" }}
          />
        ))}
      </Tabs>

      <Box sx={{ marginTop: "10px" }}>{renderTabContent()}</Box>
    </Paper>
  );
};

export default LabSettings;
